module.exports = __webpack_public_path__ + "images/home-finance.jpg?d3ecd15";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/home-finance.jpg
// module id = 336
// module chunks = 0